import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { TransactionHistoryService } from '../../_services/transaction/transaction-history.service';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Router } from '@angular/router';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { InfoPopupComponent } from '../../sharedcomponents/_directive/info-popup/info-popup.component';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { overlayConfigFactory } from 'angular2-modal';
import { CartServiceService } from '../../_services/dashboardservice/cart/cart-service.service';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import { ShopingCart } from 'app/models/dashboard/cart/mywallet.currentcart.Modal';

@Component({
  selector: 'app-transaction-list-user',
  templateUrl: './transaction-list-user.component.html',
  styleUrls: ['./transaction-list-user.component.css'],
  providers: [Modal]
})
export class TransactionListUserComponent implements OnInit {
  beneficiaryID: string;
  beneficiaryuserDetail: any = [];
  documentRequireStatus = '';
  orderDetailList: any = [];
  loadSecondScreen = 0;
  selctedBenificary;
  selectedIndex = -1;
  mobHeight: any;
  mobWidth: any;
  mobileScreen = false;
  showBothScreen = false;
  enableBackButton: boolean;
  OrderList = [];
  OrderStatusList = [];
  constructor(
    public utilserv: utilityService,
    public transHistory: TransactionHistoryService,
    private translate: TranslateService,
    private router: Router,
    public modal: Modal,
    private vcRef: ViewContainerRef,
    private alertService: AlertService,
    private cartservice: CartServiceService,
    private _location: Location
  ) {
    this.transHistory.gettransactionhistoryData().subscribe(data => {
      this.beneficiaryID = this.utilserv.getObjectText(data.Beneficiary.BeneficiaryId);
    });
  }

  ngOnInit() {
    this.enableBackButton = false;
    const selectIndex$ = this.transHistory.gettransactionhistorySelectIndex().subscribe(data => {
      this.selectedIndex = this.utilserv.getObjectText(data);
    });
    if (this.beneficiaryID != undefined || this.beneficiaryID != '') {
      this.getusertranscationlist('', this.beneficiaryID);
    }
    if (selectIndex$ != undefined) {
      selectIndex$.unsubscribe();
    }
  }
  getusertranscationlist(orderid, beneficiaryid) {
    this.utilserv.busy = this.transHistory.gettransactionlistservice(orderid, beneficiaryid).subscribe(data => {
      const response = data.Envelope.Body.OutGoingTransactionResponse;
      if (response.StatusCode == enumStatusCodeList.TokenInvalidOrExpired) {
        return false;
      }
      if (response.StatusCode == enumStatusCodeList.SUCCESS) {
        try {
          this.beneficiaryuserDetail = response.BeneficiaryTransactions.BeneficiaryTransaction.Beneficiary;
          this.documentRequireStatus = this.utilserv.getObjectText(response.BeneficiaryTransactions.BeneficiaryTransaction.DocumentRequiredStatus);
          this.orderDetailList = this.utilserv.getArray(response.BeneficiaryTransactions.BeneficiaryTransaction.Orders.OrderDetail);
          _.sortBy(this.orderDetailList, 'OrderDate');
          this.showusertranscation(-1, this.orderDetailList[0]);
          this.loadSecondScreen = 1;
        } catch (ex) {
          console.log(ex);
          this.beneficiaryuserDetail.FirstName = '';
          this._location.back();
        }
      } else {
        this.beneficiaryuserDetail.FirstName = '';
        this.loadSecondScreen = 0;
        this._location.back();
      }
    });
  }

  showusertranscation(listIndex, benificaryDetail) {
    if (listIndex == -1) {
      listIndex = 0;
      this.showBothScreen = false;
    } else {
      this.showBothScreen = true;
    }

    this.selectedIndex = listIndex;
    this.enableBackButton = true;
    benificaryDetail.beneficiaryuserDetail = this.beneficiaryuserDetail;
    this.transHistory.settransbenifcaryDetailData(benificaryDetail);
    this.transHistory.settransactionhistorySelectIndex(listIndex);
    this.selctedBenificary = this.utilserv.getObjectText(benificaryDetail.BeneficiaryId);
    if (document.getElementById(benificaryDetail.OrderNumber.__text) != undefined) {
      document.getElementById(benificaryDetail.OrderNumber.__text).classList.add('red');
    }
  }

  deleteitemfromcartforCanceltrans(orderObj) {
    this.modal.overlay.defaultViewContainer = this.vcRef;
    const _self = this;
    const modalData: any = {};
    const path = _self.router.url.split('/')[1];
    modalData.Title = this.translate.instant('Common_lblConfirm');
    modalData.Message = _self.translate.instant('DeleteCartItemPopup_desc');
    return _self.modal.open(InfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
      obj.onDestroy.subscribe(data => {
        console.log('Observer got a next value: ' + data);
        if (modalData.next == 'yes') {
          _self.utilserv.busy = _self.cartservice.deletetransitem(_self.utilserv.getObjectText(orderObj.OrderNumber)).subscribe(
            canceldata => {
              try {
                if (canceldata.StatusCode == enumStatusCodeList.SUCCESS) {
                  // _self.ngOnInit();
                  if (path == 'transactionuserlist') {
                    _self.router.navigate(['/transactionuserlists']);
                  } else {
                    _self.router.navigate(['/transactionuserlist']);
                  }
                } else {
                  _self.alertService.openErrorAlert(_self.translate.instant('Common_lblOops'), canceldata.Envelope.Body.ResponseBase.StatusMessage);
                }
              } catch (ex) {
                console.log('Something went wrong,Unable to delte cart Item');
              }
            },
            error => {
              console.log('Something went wrong,Unable to delte cart Item' + error);
            }
          );
        }
      });
    });
  }
  // getOrderStatus() {
  //   this.utilserv.busy = this.transHistory.getOrderItemStatus(this.OrderList).subscribe(
  //     data => {
  //       if (data.Envelope.Body.OrderStatusResponse.StatusCode == enumStatusCodeList.SUCCESS) {
  //         this.OrderStatusList = this.utilserv.getArray(data.Envelope.Body.OrderStatusResponse.OrdersStatus.CartOrderStatus);
  //       }
  //     },
  //     error => {
  //       console.log('Unable to getOrderStatus' + error);
  //     }
  //   );
  // }
  // getOrderStatusObj(item): any {
  //   return this.OrderStatusList.filter(function(element) {
  //     return this.utility.getObjectText(element.ItemId) == item;
  //   });
  // }
  back() {
    this.mobileScreen = true;
    this.showBothScreen = false;
  }
  ValidateMobileScreen(screen) {
    this.showBothScreen = screen.showBothScreen;
    this.mobileScreen = screen.mobileScreen;
    // this.enableBackButton = screen.enableBackButton;
  }
}



// WEBPACK FOOTER //
// ./src/app/transaction-history/transaction-list-user/transaction-list-user.component.ts